/* eslint-disable eqeqeq */
import React from 'react';
import { container } from 'tsyringe';
import { PengajuanPelatihanPresenter } from '../../../../../../../data/presenters/PengajuanPelatihanPresenter';
import { toast } from 'react-toastify';
import history from '../../../../../../../history';
import moment from 'moment';
import { PengajuanPelatihan } from '../../../../../../../entities/PengajuanPelatihan';
import { JenisPelatihan } from '../../../../../../../entities/JenisPelatihan';
import { JenisPelatihanPresenter } from '../../../../../../../data/presenters/JenisPelatihanPresenter';
import { SubMenuJenisPelatihan } from '../../../../../../../entities/MenuJenisPelatihan';
import { MenuJenisPelatihanPresenter } from '../../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import axiosInstance from '../../../../../../api/axiosInstance';

type OptionType = {
  value: string;
  label: string;
};
interface IState {
  isLoading: boolean;
  path_thumbnail: any;
  jenis_pelatihan_id: number;
  sub_menu_jenis_pelatihan_id: number;
  waktu_mulai: string;
  waktu_selesai: string;
  waktu_mulai_pendaftaran: string;
  waktu_selesai_pendaftaran: string;
  penyelenggara: string;
  informasi_umum: string;
  kompetensi_teknis: string;
  persyaratan: string;
  angkatan: string;
  pelatihan: PengajuanPelatihan | null;
  jenisPengajuanPelatihan: JenisPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  status_publish: boolean;
  isPPKB: boolean;
  materiInti: string;
  isForGuruMadrasah: boolean;
  listOptionsJenisPenilaian: OptionType[];
  jenisPenilaianSelected: OptionType | null;
  jenisPenilaianId: string;
  judulPelatihan: string;
  linkEvaluasi: string;
  accessLinkEvaluasi: boolean;
  logoPenyelenggara: any;
}

interface InitialState {
  state: IState;
  updatePengajuanPelatihan: Function;
  setPathThumbnail: Function;
  setJenisPelatihanId: Function;
  setSubMenuJenisPelatihanId: Function;
  setWaktuMulai: Function;
  setWaktuSelesai: Function;
  setWaktuMulaiPendaftaran: Function;
  setWaktuSelesaiPendaftaran: Function;
  setPenyelenggara: Function;
  setInformasiUmum: Function;
  setKompetensiTeknis: Function;
  setPersyaratan: Function;
  setAngkatan: Function;
  getDetailPengajuanPelatihan: Function;
  getJenisPelatihan: Function;
  getSubMenuJenisPelatihan: Function;
  setIsPPKB: Function;
  setUpdateManajemenPengajuanPelatihan: Function;
  getJenisPenilaian: Function;
  setJenisPenilaian: Function;
  setJudulPelatihan: Function;
  setLinkEvaluasi: Function;
  setAccessLinkEvaluasi: Function;
  setLogoPenyelenggara: Function;
}

const initialState = {
  state: {
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    pelatihan: null,
    jenisPengajuanPelatihan: [],
    subMenuJenisPelatihan: [],
    status_publish: false,
    isPPKB: false,
    materiInti: '',
    isForGuruMadrasah: false,
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    jenisPenilaianId: '',
    judulPelatihan: '',
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
  },
  updatePengajuanPelatihan: () => {},
  setPathThumbnail: () => {},
  setJenisPelatihanId: () => {},
  setSubMenuJenisPelatihanId: () => {},
  setWaktuMulai: () => {},
  setWaktuSelesai: () => {},
  setWaktuMulaiPendaftaran: () => {},
  setWaktuSelesaiPendaftaran: () => {},
  setPenyelenggara: () => {},
  setInformasiUmum: () => {},
  setKompetensiTeknis: () => {},
  setPersyaratan: () => {},
  setAngkatan: () => {},
  getDetailPengajuanPelatihan: () => {},
  getJenisPelatihan: () => {},
  getSubMenuJenisPelatihan: () => {},
  setIsPPKB: () => {},
  setUpdateManajemenPengajuanPelatihan: () => {},
  getJenisPenilaian: () => {},
  setJenisPenilaian: () => {},
  setJudulPelatihan: () => {},
  setLinkEvaluasi: () => {},
  setAccessLinkEvaluasi: () => {},
  setLogoPenyelenggara: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPengajuanPelatihanUpdateProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    pelatihan: null,
    jenisPengajuanPelatihan: [],
    subMenuJenisPelatihan: [],
    status_publish: false,
    isPPKB: false,
    materiInti: '',
    isForGuruMadrasah: false,
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    jenisPenilaianId: '',
    judulPelatihan: '',
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
  });

  const setUpdateManajemenPengajuanPelatihan = <K extends keyof IState>(
    key: K,
    value: IState[K]
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      [key]: value,
    }));
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const updatePengajuanPelatihan = async (id: number) => {
    setLoading(true);

    if (
      state.jenis_pelatihan_id == 0 ||
      state.sub_menu_jenis_pelatihan_id == 0 ||
      state.waktu_mulai == '' ||
      state.waktu_selesai == '' ||
      state.waktu_mulai_pendaftaran == '' ||
      state.waktu_selesai_pendaftaran == '' ||
      state.penyelenggara == '' ||
      state.informasi_umum == '' ||
      state.persyaratan == '' ||
      state.angkatan == '' ||
      (state.accessLinkEvaluasi && state.linkEvaluasi == '')
    ) {
      toast('Data Belum Terisi Lengkap!');
      setLoading(false);
      return;
    }

    try {
      const pelatihanPresenter = container.resolve(PengajuanPelatihanPresenter);

      const update = await pelatihanPresenter.updatePengajuanPelatihan(
        state.pelatihan?.id as number,
        state.sub_menu_jenis_pelatihan_id,
        state.jenis_pelatihan_id,
        state.judulPelatihan,
        state.jenisPenilaianSelected?.value as string,
        moment(state.waktu_mulai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_mulai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai).format('YYYY-MM-DD HH:mm:ss'),
        state.penyelenggara,
        state.informasi_umum,
        state.persyaratan,
        state.angkatan,
        state.kompetensi_teknis,
        state.isPPKB,
        state.isPPKB ? state.materiInti : '',
        state.isForGuruMadrasah,
        state.path_thumbnail,
        'diajukan',
        state.linkEvaluasi,
        state.logoPenyelenggara
      );

      const data = update;

      if (data.data.code == 200) {
        toast('Berhasil Ubah Data .');

        history.replace(
          `/admin/kelola_konten/manajemen_pengajuan_pelatihan/${data.data.data.uuid}`
        );
        window.location.reload();
      } else {
        toast('Ada Kesalahan Saat Ubah Data!');
      }
      setLoading(false);
    } catch (error: any) {
      console.log('error pelatihan:', error);
      toast('Ada Kesalahan Saat Ubah Data!');
      setLoading(false);
    }
  };

  const setPathThumbnail = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      path_thumbnail: value,
    }));
  };

  const setJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jenis_pelatihan_id: value,
    }));
  };

  const setSubMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      sub_menu_jenis_pelatihan_id: value,
    }));
  };

  const setWaktuMulai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai: value,
    }));
  };

  const setWaktuSelesai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai: value,
    }));
  };

  const setWaktuMulaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai_pendaftaran: value,
    }));
  };

  const setWaktuSelesaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai_pendaftaran: value,
    }));
  };

  const setPenyelenggara = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      penyelenggara: value,
    }));
  };

  const setInformasiUmum = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      informasi_umum: value,
    }));
  };

  const setKompetensiTeknis = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      kompetensi_teknis: value,
    }));
  };

  const setPersyaratan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      persyaratan: value,
    }));
  };

  const setAngkatan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      angkatan: value,
    }));
  };

  const setIsPPKB = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPPKB: value,
    }));
  };

  const setJudulPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      judulPelatihan: value,
    }));
  };

  const getDetailPengajuanPelatihan = async (id: number) => {
    try {
      const pelatihanPresenter = container.resolve(PengajuanPelatihanPresenter);
      const getDetail = await pelatihanPresenter.getDetailPengajuanPelatihan(
        id
      );

      const data = getDetail;

      setState((prevstate) => ({
        ...prevstate,
        pelatihan: data,
        jenis_pelatihan_id: data.jenis_pelatihan_id,
        sub_menu_jenis_pelatihan_id: data.sub_menu_jenis_pelatihan_id,
        waktu_mulai: data.waktu_mulai,
        waktu_selesai: data.waktu_selesai,
        waktu_mulai_pendaftaran: data.waktu_buka_pendaftaran,
        waktu_selesai_pendaftaran: data.waktu_tutup_pendaftaran,
        penyelenggara: data.penyelenggara,
        informasi_umum: data.informasi_umum,
        persyaratan: data.persyaratan,
        angkatan: data.angkatan,
        kompetensi_teknis: data.kompetensi_teknis,
        isPPKB: data.is_ppkb === 1 ? true : false,
        materiInti: data.materi_inti,
        path_thumbnail: data.path_thumbnail,
        isForGuruMadrasah: data.is_for_guru_madrasah === 1 ? true : false,
        jenisPenilaianId: data?.jenis_penilaian_id.toString(),
        accessLinkEvaluasi: data?.link_evaluasi != '' ? true : false,
        linkEvaluasi: data?.link_evaluasi,
        logoPenyelenggara: data?.logo_penyelenggara,
      }));

      getJenisPelatihan(data.sub_menu_jenis_pelatihan_id.toString());
    } catch (error: any) {
      console.log('error get pelatihan:', error);
      setLoading(false);
    }
  };

  const getJenisPelatihan = async (sub_menu_jenis_pelatihan_id: string) => {
    try {
      const jenisPengajuanPelatihan = container.resolve(
        JenisPelatihanPresenter
      );

      const get = await jenisPengajuanPelatihan.getAllJenisPelatihan(
        1,
        10000000,
        '',
        sub_menu_jenis_pelatihan_id
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        jenisPengajuanPelatihan: data,
      }));
    } catch (error: any) {
      console.log('error get Jenis PengajuanPelatihan:', error);
    }
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );

      const get = await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
        1,
        10000000,
        ''
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));
    } catch (error: any) {
      console.log('error get Sub Menu Jenis PengajuanPelatihan:', error);
    }
  };

  const setJenisPenilaian = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPenilaianSelected: value,
    }));
  };

  const getJenisPenilaian = async () => {
    try {
      const { data } = await axiosInstance.get('jenis_penilaian');
      const listJenisPenialain = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.nama_jenis_penilaian,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listOptionsJenisPenilaian: listJenisPenialain,
      }));
    } catch (error) {
      throw error;
    }
  };

  const setLinkEvaluasi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      linkEvaluasi: value,
    }));
  };

  const setAccessLinkEvaluasi = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      accessLinkEvaluasi: value,
    }));

    if (!value) {
      setState((prevstate) => ({
        ...prevstate,
        linkEvaluasi: '',
      }));
    }
  };

  const setLogoPenyelenggara = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      logoPenyelenggara: value,
    }));
  };

  return (
    <ManajemenPengajuanPelatihanUpdateProvider
      value={{
        state,
        updatePengajuanPelatihan,
        setPathThumbnail,
        setJenisPelatihanId,
        setSubMenuJenisPelatihanId,
        setWaktuMulai,
        setWaktuSelesai,
        setWaktuMulaiPendaftaran,
        setWaktuSelesaiPendaftaran,
        setPenyelenggara,
        setInformasiUmum,
        setKompetensiTeknis,
        setPersyaratan,
        setAngkatan,
        getDetailPengajuanPelatihan,
        getJenisPelatihan,
        getSubMenuJenisPelatihan,
        setIsPPKB,
        setUpdateManajemenPengajuanPelatihan,
        getJenisPenilaian,
        setJenisPenilaian,
        setJudulPelatihan,
        setLinkEvaluasi,
        setAccessLinkEvaluasi,
        setLogoPenyelenggara,
      }}
    >
      {children}
    </ManajemenPengajuanPelatihanUpdateProvider>
  );
};

export const useManajemenPengajuanPelatihanUpdateContext = () =>
  React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenPengajuanPelatihanUpdateContext,
  Provider,
};
